import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["language"];
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { rpcClient } from '../../client';
import { getVaasRecommendationsRpc } from 'academy-service-client/academy-ai/v1/operations';
import getLang from 'academy-common-lib/utils/getLang';
import { MY_SAVED_ITEMS_PAGE_SIZE } from '../savedItems/savedItemsTypes';
export const GET_ACADEMY_AI_RECOMMENDATIONS_FOR_LEARNING_CONTENT = registerQuery({
  fieldName: 'academyAiRecommendationsForLearningContent',
  args: ['sourceId', 'sourceContentType', 'language', 'resultTypes', 'numberOfResults', 'offset'],
  fetcher(_ref) {
    let {
        language
      } = _ref,
      data = _objectWithoutPropertiesLoose(_ref, _excluded);
    return rpcClient.call(getVaasRecommendationsRpc, {
      data,
      pathParameters: {
        language
      }
    });
  }
});
export const useAiRecommendationsForLearningContent = ({
  item: {
    id,
    type,
    language
  },
  size = MY_SAVED_ITEMS_PAGE_SIZE,
  offset,
  resultTypes = ['TRACK', 'LESSON', 'SHORT_FORM_CONTENT'],
  skip
}) => {
  // todo: remove this mapping once the backend uses the correct type for courses
  const mappedResultTypes = resultTypes.map(t => t === 'TRACK' ? 'COURSE' : t);
  const mappedSourceContentType = type === 'TRACK' ? 'COURSE' : type;
  const {
    data: recommendationsResponse,
    loading: recommendationsLoading,
    error: recommendationsError
  } = useQuery(GET_ACADEMY_AI_RECOMMENDATIONS_FOR_LEARNING_CONTENT, {
    variables: {
      sourceId: id,
      sourceContentType: mappedSourceContentType,
      numberOfResults: size,
      language: language || getLang(),
      offset,
      resultTypes: mappedResultTypes,
      vaasThreshold: 0.1,
      // minimum semantic similarity to match the content-chunk
      vaasTopK: 40 // number of max results returned from vaas
    },
    skip
  });
  const {
    results: recommendations,
    correlationId,
    hasMore,
    offset: nextOffset
  } = recommendationsResponse || {};
  return {
    // todo: remove this mapping once the backend uses the correct type for courses
    recommendations: recommendations === null || recommendations === void 0 ? void 0 : recommendations.map(r => r.recommendationType === 'COURSE' ? Object.assign({}, r, {
      recommendationType: 'TRACK'
    }) : r),
    recommendationsLoading,
    recommendationsError,
    correlationId,
    hasMore,
    nextOffset
  };
};